import { Icon } from "@iconify/react";
import androidFilled from "@iconify/icons-ant-design/android-filled";
import navigation2Fill from "@iconify/icons-eva/navigation-2-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
import { ResponseModel } from "../../../types/ResponseModel";
import { productService } from "../../../services/productService";
import { useEffect, useState } from "react";
import React from "react";
import { linkService } from "../../../services/linkService";

// ----------------------------------------------------------------------
const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter,
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: "center",
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(
    theme.palette.error.dark,
    0
  )} 0%, ${alpha(theme.palette.error.dark, 0.24)} 100%)`,
}));
// ----------------------------------------------------------------------

export default function DashboardKategori() {
  const [totalClick, setTotalClick] = useState(0);
  useEffect(() => {
    linkService.getTotalClick().then(({ data }: { data: ResponseModel }) => {
      setTotalClick(data.data);
    });
  }, []);
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={navigation2Fill} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(totalClick)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Tıklanma Sayısı
      </Typography>
    </RootStyle>
  );
}
